export default __webpack_public_path__ + "static/media/1_Background_Check_Icon.5baf5581.svg";